import { useMemo, useCallback } from "react";

export default function useRoles() {
  const defaultRoles = {
    SuperAdministrator: "SuperAdministrator",
    Administrator: "Administrator",
    Committee: "Committee",
    Performer: "Performer",
  };

  // Сырые строки стабильны между рендерами — иначе JSON.parse даёт новый объект
  // каждый раз и ломает useEffect([employee]) / useMemo([roles]).
  const rolesRaw = localStorage.getItem("roles");
  const employeeRaw = localStorage.getItem("employee");

  const roles = useMemo(() => {
    if (!rolesRaw || rolesRaw.length === 0) return [];
    try {
      return JSON.parse(rolesRaw) || [];
    } catch (e) {
      return [];
    }
  }, [rolesRaw]);

  const employee = useMemo(() => {
    if (!employeeRaw || employeeRaw === "undefined") return null;
    try {
      return JSON.parse(employeeRaw);
    } catch (e) {
      return null;
    }
  }, [employeeRaw]);

  const isInRole = useCallback(
    (role) => roles.find((r) => r == role) != null,
    [roles]
  );

  const isInRoles = useCallback(
    (values) => values.find((v) => isInRole(v)),
    [isInRole]
  );

  const isAdministrator = useCallback(
    () =>
      isInRoles([defaultRoles.SuperAdministrator, defaultRoles.Administrator]),
    [isInRoles]
  );

  const isCommittee = useCallback(
    () => isInRole(defaultRoles.Committee),
    [isInRole]
  );

  const isPerformer = useCallback(
    () => isInRole(defaultRoles.Performer),
    [isInRole]
  );

  const getEmployee = useCallback(() => employee, [employee]);

  return {
    roles,
    isInRole,
    isInRoles,
    isAdministrator,
    isCommittee,
    getEmployee,
    isPerformer,
    defaultRoles,
    employee,
  };
}
